<template>
  <div>
    <div class="breadcrumb-list">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active" v-if="user && user.type=='MANAGER'"><span
          style="font-size: 13px; font-weight: bold;">Employee Name:</span> <span style="color: blue;">{{
            employee.name
          }}</span></li>
      </ol>
    </div>
    <div class="attendance-report tbl-responsive">
      <div class="input-wrap w-348 d-flex mb-10 align-items-center select-drop">
        <h2 class="mb-0">Timesheet for Week</h2>
        <select class="form-select form-control ab-select mx-10" v-model="allDates" @change="getAttendancesAndDates">
          <option v-for="(weeks,index) in weekDates" :key="index">{{ weeks }}</option>
        </select>
        <div>
          <button class="btn btn-primary" v-show="isAnyRowAdded" type="button" @click="submitTimeSheetWeekReport()"
                  v-if="employeeWeeklyTimeSheet.length==0 || employeeWeeklyTimeSheet.status=='Pending'">Submit
          </button>
        </div>
      </div>

      <p v-show="errorMessage" class="text-red error-text">Should Be Less Than Working Hours of the Day</p>
      <p v-show="errorMessage1" class="text-red error-text">Project cannot have same activities</p>
      <table class="client-table">
        <thead>
        <tr>
          <th></th>
          <th>Project Name</th>
          <th>Product Activity</th>
          <th v-for="(date, index) in dates" :key="index" :class="'dateTime'+index" :data-hours="date.hours">
            <!--            <pre class="language-json"><code>{{ date }}</code></pre>-->
            {{ date.date }}
          </th>
        </tr>
        </thead>
        <tbody v-if="!loadingSpin && tableRows">
        <tr v-for="(row,rowIndex) in tableRows" :key="rowIndex" :id="'tableRows'+rowIndex">
          <td>
            <div class="sticky-check">
              <label class="custom-check-box">
                <input type="checkbox" name="check02"
                       :id="'checkBoxInput_'+rowIndex"
                       class="customer_id_ckbx"
                       :value="(row.dates[rowIndex])?row.dates[rowIndex].id:row.row_id"
                       v-model="row.checked"/>
                <!-- v-model="selected" v-on:change="selectedcustomer_id" -->
                <span class="radio-check text-capitalize"> </span>
              </label>
            </div>
          </td>
          <td>
            <div class="input-wrap wrap-width">
              <!--              <pre class="language-json"><code>{{ row.project_id }}</code></pre>-->
              <input type="text" v-model="searchQueries[rowIndex]" class="form-control" placeholder="Search Project">
              <select class="form-select form-control" :id="'projectInput_'+rowIndex"
                      @change="getAllActivities($event,rowIndex+'act')" v-model="row.project_id">
                <option value="project" class="ab-cstplace">
                  Select Project
                </option>
                <option v-for="(project, index) in filteredProjects(rowIndex)" :key="index" :value="project.id">
                  {{ project.name }}
                </option>
              </select>

            </div>
          </td>
          <td>
            <div class="input-wrap wrap-width">
              <select class="form-select form-control activity-validation" :id="'activityInput_'+rowIndex"
                      v-model="row.activity_id" @change="validationTimeSheet()">
                <option value="project" class="ab-cstplace">Select Activities</option>
                <option v-for="(activity, index) in projectActivities[rowIndex+'act']" :key="index"
                        :value="activity.id"> {{ activity.name }}
                </option>
              </select>
            </div>
          </td>

          <td v-for="(dat,ind) in row.dates" :key="ind">
            <div class="input-wrap" :clickToClose="false">
              <input type="text" class="form-control" :class="'timeSpent_'+ind" :id="'timeInput_'+rowIndex+'_'+ind"
                     :value="dat.hours" v-workingTime @focusout="validateTime($event,ind)"/>
              <textarea class="d-none" :name="'savedNoteInput_'+rowIndex+'_'+ind"
                        :id="'savedNoteInput_'+rowIndex+'_'+ind">{{ dat.notes }}</textarea>
              <a href="javascript:void(0);" class="msg-modal" data-toggle="modal"
                 :data-target="'#messageModal_'+rowIndex+'_'+ind">
                <span class="ico-message-icon"></span>
              </a>
            </div>
            <div class="my-modal modal fade" :id="'messageModal_'+rowIndex+'_'+ind" data-backdrop="static">
              <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                  <div class="modal-body p-20">
                    <h5 class="modal-title text-left">Add Message:</h5>
                    <textarea rows="4" class="txtarea-responsive"
                              :id="'noteInput_'+rowIndex+'_'+ind">{{ dat.notes }}</textarea>
                    <img v-if="dat.file" :src="filePath(dat.file)" width="100" height="100" alt="">
                    <input type="file" class="form-control upload-files" :id="'file'+rowIndex+'_'+ind"
                           :name="'file'+rowIndex+'_'+ind" @change="onFileChange($event, rowIndex, ind)">
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal"
                        @click="closeModal(rowIndex+'_'+ind)"
                      >
                        Close
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="savechanges(rowIndex+'_'+ind)"
                        data-dismiss="modal"
                      >
                        Save changes
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
        <tbody v-if="!loadingSpin && tableRows.length==0">
        <tr>
          <td colspan="10">
            No Data Found
          </td>
        </tr>
        </tbody>
      </table>
      <div class="d-flex justify-content-center">
        <clip-loader :loading="loadingSpin" :size="size" :color="spinnerColor"></clip-loader>
      </div>
      <div class="tbl-bottom-btn" v-if="employeeWeeklyTimeSheet.length==0 || employeeWeeklyTimeSheet.status=='Pending'">
        <div class="btns-left">
          <button type="button" @click="insertRow()" class="btn btn-outline-primary">Add Row</button>
          <button v-show="isAnyCheckboxChecked" type="button" class="btn btn-outline-danger" @click="removeRow()">Remove
            Row
          </button>
        </div>
        <div class="btns-right" v-show="isAnyRowAdded">
          <router-link :to="{name:'timesheets'}" class="btn btn-outline-dark" v-if="user && user.type=='MANAGER'">
            Cancel
          </router-link>
          <button type="button" class="btn btn-outline-dark" @click="rowReset()">Reset</button>
          <button type="button" :disabled="timeCheckBtn" class="btn btn-outline-primary" @click="savelatest()">Save
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import moment from "moment";
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';
import Multiselect from "vue-multiselect";
import DateWithNotes from "./dateWithNotes.vue";


export default {
  name: "editTimeSheet",
  components: {
    Multiselect,
    DateWithNotes,
    ClipLoader
  },
  directives: {
    workingTime: {
      bind(el) {
        el.addEventListener('input', (e) => {
          let inputValue = e.target.value;
          const regex = /[^0-9:]/g;
          inputValue = inputValue.replace(regex, '');
          e.target.value = inputValue;
        });
      },
    },
  },

  data() {
    return {
      size: '25px',
      spinnerColor: '#00779C',
      loadingSpin: false,
      selectedCompany: this.$store.getters.getSelectedCompany,
      tableRows: [],
      employee: {},
      projectUnderWork: [],
      activityUnderWork: '',
      projectActivities: [],
      selected: [],
      userAttendances: [],
      activities: [],
      allDates: '',
      selectedProjects: [],
      weekDates: [],
      date: "",
      startDate: [],
      endDay: [],
      endDate: [],
      startDay: [],
      dates: [],
      Activityname: [],
      activitiesId: [],
      Alldata: [],
      count: 1,
      savedData: [],
      myDates: [],
      Allids: [],
      projectId: "",
      emlpoyeeTimeSheet: [],
      projects: [],
      sortedAttendances: '',
      rowstoremove: [],
      timeCheckBtn: false,
      errorMessage: false,
      errorMessage1: false,
      sheetData: [],
      user: this.$store.getters.getUser,
      TemProjectActivities: [],
      unsavedNotes: "",
      searchQueries: [],
      employeeWeeklyTimeSheet: "",
      formFiles: [],
      isAnyRowAdded: false,
    };
  },

  created() {
    this.getProjects();
  },
  computed: {
    isAnyCheckboxChecked() {
      return this.tableRows.some(row => {
        return row.checked === true;
      });
    }
  },
  watch: {
    tableRows: {
      handler(newRows) {
        this.isAnyRowAdded = newRows.length > 0;
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.tableRows.length > 0) {
      this.isAnyRowAdded = true;
    }
  },

  methods: {
    filteredProjects(rowIndex) {
      const searchQuery = this.searchQueries[rowIndex] || ''; // Get the search query for the specific row
      return this.projects.filter(project =>
        project.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
    },
    filePath(file) {
      return this.filePathCommon(file);
    },
    validationTimeSheet() {
      let self = this;
      self.timeCheckBtn = false;
      self.errorMessage1 = false;
      $('.activity-validation').css("border-color", "#bebebe");
      let validation = [];
      let timeCheckBtn = false;
      this.tableRows.forEach(function (elem, indx) {
        let curentRow = $('#activityInput_' + indx).val() + '_' + $('#projectInput_' + indx).val()
        if (validation.includes(curentRow)) {
          if (curentRow.search("null")) {
            let errorIndex = validation.indexOf(curentRow);
            $('#activityInput_' + errorIndex).css("border-color", "red");
            $('#activityInput_' + indx).css("border-color", "red");
          }
          self.timeCheckBtn = self.errorMessage1 = true;
        }
        validation.push(curentRow);
      })
    },
    validateTime(event, indx) {

      let self = this;
      self.timeCheckBtn = false;
      self.errorMessage = false;
      let totalWorkedHours = $('.dateTime' + indx).attr('data-hours');
      $(event.target).css("border-color", "#bebebe");

      let totalTimeSpent = [];
      let timeSpent = [];
      for (let i = 0; i < self.tableRows.length; i++) {
        let rowTimeValidation = self.tableRows[i];
        rowTimeValidation.dates.forEach(function (row, ridx) {
          let enterHrs = $('#timeInput_' + i + '_' + ridx).val();
          if (enterHrs) {
            let timeFormat = enterHrs.split(":");
            if (timeFormat.length == 1) {
              timeFormat[1] = (timeFormat[1]) ? timeFormat : '00';
              enterHrs = timeFormat.join(':');
            }
            let newHrs = moment.duration(enterHrs).asMinutes()
            if (timeSpent[ridx] == undefined) {
              timeSpent[ridx] = newHrs;
            } else {
              let totalHrs = timeSpent[ridx];
              timeSpent[ridx] = parseFloat(totalHrs) + parseFloat(newHrs);
            }
          } else {
            timeSpent.push(enterHrs);
          }
          let rowTotalHrs = $('.dateTime' + ridx).attr('data-hours');
          if (enterHrs && rowTotalHrs != undefined) {
            self.tableRows[i].dates[ridx].hours = enterHrs
          }
        })
      }
      timeSpent.forEach(function (hrs, hrsidx) {
        let rowTotalHrs = $('.dateTime' + hrsidx).attr('data-hours');
        $('.timeSpent_' + hrsidx).css("border-color", "#bebebe");
        if (rowTotalHrs == undefined) {
          $('.timeSpent_' + hrsidx).val('');
        } else {
          rowTotalHrs = moment.duration(rowTotalHrs).asMinutes();
          if (rowTotalHrs < hrs) {
            $('.timeSpent_' + hrsidx).css("border-color", "red");
            self.timeCheckBtn = self.errorMessage = true;
          }
        }
      })
    },

    submitTimeSheetWeekReport() {
      this.loadingSpin = true;
      let params = {
        id: this.employeeWeeklyTimeSheet.id,
        employee_id: this.$route.params.id,
        status: 'Submit',
      };
      this.$axios.get(this.$StatusTimeSheet, {
        params: params,
        headers: this.getAuthHeader(),
      })
        .then((res) => {
          if (res.data.status === 200) {
            this.employeeWeeklyTimeSheet = res.data.result;
            $root.$toast.success('Submitted Successfully');
          }
        });
      this.loadingSpin = false;
    },

    getTimesheetDates(dateRange = '') {
      this.loadingSpin = true;
      let id = this.$route.params.id;
      let params = {
        dateRange: dateRange,
        company_id: this.selectedCompany.id,
        employee_uuid: id,
      };

      this.$axios.get(this.$timeSheetDates, {
        params: params,
        headers: this.getAuthHeader(),
      })
        .then((res) => {
          this.employee = res.data.result.userWithAttendance;
          this.weekDates = res.data.result.weeks;
          this.employeeWeeklyTimeSheet = res.data.result.employeeWeeklyTimeSheet;
          this.userAttendances = res.data.result.userWithAttendance.attendances;
          this.sortedAttendances = res.data.result.userWithAttendance.sorted_attendances;
          (dateRange) ? this.getTimesheet('', dateRange) : this.getTimesheet();
          this.allDates = this.weekDates[0]
        });

    },
    getAttendancesAndDates() {
      let dateArr = this.allDates.split(' - ');
      let params = {
        dates: this.allDates,
        employee_id: this.$route.params.id,
      };

      this.getTimesheetDates(this.allDates);
    },

    getTimesheet(id = null, dateRange = this.weekDates[0]) {
      id = this.$route.params.id;
      let params = {
        dates: dateRange,
        employee_uuid: id,
      };
      this.$axios.get(this.$getEmployeeTimeSheet, {
        params: params,
        headers: this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status === 200) {
          let sheetData = res.data.result;
          let startDate = sheetData ? sheetData.start_date : null;
          let endDate = sheetData ? sheetData.end_date : null;
          let self = this;
          //console.log(dateRange,'dateRange dateRange');
          // this.allDates = startDate!==null?startDate + " - " + endDate:this.weekDates[0];
          this.allDates = dateRange.split(' - ')[0] + " - " + dateRange.split(' - ')[1]
          this.printDates();
          if (sheetData) {
            self.tableRows = [];
            let rowsData = Object.values(sheetData.groupedtimesheet);
            rowsData.forEach((item, index) => {
              self.tableRows.push({
                dates: item,
                project_id: item[0].project_id,
                activity_id: item[0].activity_id
              });
              this.projectActivities[index + 'act'] = this.TemProjectActivities[item[0].project_id];
            })

          }
        }
      });
    },

    getProjects() {
      this.loadingSpin = true;
      let params = {
        company_id: this.selectedCompany.id,
      };
      this.$axios.get(this.$GetProjects, {
        params: params,
        headers: this.getAuthHeader(),
      })
        .then((res) => {
          if (res.data.status === 200) {
            res.data.result.forEach((item) => {
              this.TemProjectActivities[item.id] = item.activities;
            });
            this.projects = res.data.result;
            this.getTimesheetDates();
          }
        });
    },
    getAllActivities(event, indx) {
      let activity = [];
      this.projects.map((pro) => {
        if (pro.id == parseInt(event.target.value)) {
          activity = pro.activities;
        }
      });
      this.projectActivities[indx] = activity;
      // Make proper index for activity validation
      this.validationTimeSheet();
    },
    selectedcustomer_id(id) {
      var ids = [];
      $("input:checked.customer_id_ckbx").each((ind, element) => {
        let id = $(element).val();
        if (!ids.includes(id)) {
          ids.push(id);
        }
      });
      this.Allids = ids;
    },
    printDates() {
      let arr = this.allDates.split(' - ');
      this.startDate = arr[0];
      this.endDate = arr[1];
      this.dates = [];
      const m = moment(arr[0]);
      const m2 = moment(arr[1]);
      this.startDay = m.format("D");
      this.endDay = m2.format("D");
      this.myDates = [];
      this.tableRows = [];
      for (var d = moment(this.startDate); d.isSameOrBefore(this.endDate); d.add(1, "days")) {
        let addDateFlag = 0;
        let timeDiffArr = [];
        if (d.format("YYYY-MM-DD") in this.sortedAttendances) {
          Object.values(this.sortedAttendances[d.format("YYYY-MM-DD")]).map((attend) => {

            let start = moment(attend.punch_in_time, "YYYY-MM-DD HH:mm:ss");
            let outTime = (attend.punch_out_time) ? attend.punch_out_time : moment().format('YYYY-MM-DD HH:mm:ss');
            let end = moment(outTime, "YYYY-MM-DD HH:mm:ss");

            var hours = end.diff(start, 'hours');
            var minutes = moment.utc(moment(end, "HH:mm:ss").diff(moment(start, "HH:mm:ss"))).format("mm");

            var currentDateTime = moment().format('YYYY-MM-DD HH:mm:ss')
            let shiftEndTime = attend.schedule.date + ' ' + attend.schedule.end_time;
            // Convert the strings to Date objects
            const shiftEnd = new Date(shiftEndTime);
            const current = new Date(currentDateTime);
            if (current > shiftEnd) {
              timeDiffArr.push(this.calculateAttendanceTimes(attend));
            } else {
              timeDiffArr.push(`${hours}:${minutes}`);
            }
            // console.log(shiftEndTime,'shiftTime',currentDateTime);
          })
          const sum = timeDiffArr.reduce((acc, time) => acc.add(moment.duration(time)), moment.duration());
          let minutCount = sum.minutes() < 10 ? '0' + sum.minutes() : sum.minutes();
          let calHours = [Math.floor(sum.asHours()), minutCount].join(':');
          this.dates.push({date: d.format("ddd DD") + ' - ' + calHours, hours: calHours});
          addDateFlag++;
        }
        if (addDateFlag == 0) {
          this.dates.push({date: d.format("ddd DD") + ' - Not Worked', hours: null});//- Not Worked
        }
        this.myDates.push({
          date: d.format("YYYY-MM-DD"),
          hours: null,
          comment: null,
          notes: null
        });
        // this.count++;
      }
      this.Alldata = {
        start_date: this.startDate,
        end_date: this.endDate,
        status: null,
        sheet: [],
      };
      this.tableRows.push({dates: this.myDates});
      this.loadingSpin = false;
    },

    removeRow() {
      this.tableRows.forEach((item, index) => {
        let checkbox = $("#checkBoxInput_" + index);
        if (checkbox.is(":checked")) {
          $("#tableRows" + index).remove();
          this.rowstoremove.push(checkbox.val());
          item.checked = false;

        }
      });

      if (this.rowstoremove.length === this.tableRows.length) {
        this.isAnyRowAdded = false;
      }
      this.$axios
        .delete(this.$removeRows, {
          params: {
            employee_uuid: this.$route.params.id,
            rowIds: this.rowstoremove,
          }
        })
        .then((response) => {

        })
        .catch((error) => {
          console.log("Error removing rows:", error);
        });
    },
    rowReset() {
      this.tableRows = [];
      this.rowstoremove = [];
      this.getTimesheet();
      this.getTimesheetDates();
    },
    savechanges(currentRow = '') {
      if (currentRow != '') {
        let currnetNote = $("#messageModal_" + currentRow).find('#noteInput_' + currentRow).val();
        $('#savedNoteInput_' + currentRow).html(currnetNote);
        this.savelatest();
        $("#messageModal_" + currentRow).modal('hide');
      }
    },
    closeModal(currentRow = '') {
      if (currentRow != '') {
        $('#file' + currentRow).val('');
        let currnetNote = $('#savedNoteInput_' + currentRow).html();
        $("#messageModal_" + currentRow).find('#noteInput_' + currentRow).val(currnetNote);
      }
    },
    saveRow() {
      let mapedDataArr = [];
      let weekDatesList = this.myDates.map(obj => obj.date);
      this.loadingSpin = true;
      this.tableRows.forEach(function (item, index) {
        let projectInput = $('#projectInput_' + index).val();
        let activityInput = $('#activityInput_' + index).val();
        let hoursAndNoteArr = [];

        if (projectInput && activityInput) {
          for (let i = 0; i <= 6; i++) {

            hoursAndNoteArr.push({
              hour: $('#timeInput_' + index + '_' + i).val(),
              note: $('#noteInput_' + index + '_' + i).val(),
              // note:$('#savedNoteInput_'+index+'_'+i).val(),
              // file:$('#file'+ index +'_'+i)[0].files[0]
            });
          }

          mapedDataArr.push({
            project_id: projectInput,
            activity_id: activityInput,
            hoursAndNotes: hoursAndNoteArr,
          });
        }

      });
      if (mapedDataArr.length !== 0) {
        this.$axios({
          method: "post",
          url: this.$postTimeSheetReports,

          headers: this.getAuthHeader(),
          data: {
            data: mapedDataArr,
            employee_uuid: this.$route.params.id,
            dates: this.allDates,
            weekDatesList: weekDatesList,

          },
        }).then((res) => {
          if (res.data.status == 200) {
            this.loadingSpin = false;
            $root.$toast.success('Successfully Added');

          }
        });

      }
      this.loadingSpin = false;
    },
    onFileChange(e, index, i) {
      // this.formFiles.push(e.target.files[0]);
      this.formFiles = e.target.files[0];
    },
    savelatest() {
      var mapedDataArr = [];
      let weekDatesList = this.myDates.map(obj => obj.date);
      this.loadingSpin = true;
      this.tableRows.forEach(function (item, index) {
        let projectInput = $('#projectInput_' + index).val();
        let activityInput = $('#activityInput_' + index).val();
        let hoursAndNoteArr = [];

        if (projectInput && activityInput) {
          for (let i = 0; i <= 6; i++) {

            hoursAndNoteArr.push({
              hour: $('#timeInput_' + index + '_' + i).val(),
              note: $('#noteInput_' + index + '_' + i).val(),
              // note:$('#savedNoteInput_'+index+'_'+i).val(),
              file: $('#file' + index + '_' + i)[0].files[0] ? 1 : 0
            });
          }
          mapedDataArr.push({
            project_id: projectInput,
            activity_id: activityInput,
            hoursAndNotes: hoursAndNoteArr,
          });
        }

      });

      if (mapedDataArr.length !== 0) {

        const formData = new FormData();
        formData.append('data', JSON.stringify(mapedDataArr));
        formData.append('employee_uuid', this.$route.params.id);
        formData.append('dates', this.allDates);
        formData.append('weekDatesList', weekDatesList);
        formData.append('file', this.formFiles);

        this.$axios({
          method: "post",
          url: this.$postTimeSheetReports,
          // headers: this.getAuthHeader(),
          headers: this.getImageHeader(),
          data: formData,

        }).then((res) => {
          if (res.data.status == 200) {
            this.loadingSpin = false;
            this.formFiles = [];
            $root.$toast.success('Successfully Added');

          }
        });
      }
      this.loadingSpin = false;
    },
    insertRow() {
      console.log(this.tableRows, 'start'); // Debug the structure
      let arr = this.allDates.split(' - ');
      let newDates = [];
      for (var d = moment(arr[0]); d.isSameOrBefore(arr[1]); d.add(1, "days")) {
        newDates.push({date: d.format("YYYY-MM-DD"), hours: null, comment: null, notes: null});
      }
      const newRow = { row_id: this.tableRows.length + 1, dates: newDates, project_id: "", activity_id: "" };

      this.tableRows.push(newRow);
      // this.tableRows.push({dates: newDates, project_id: '', activity_id: ''});
      this.isAnyRowAdded = true;
    },
    insertRow_old() {
      let arr = this.allDates.split(' - ');
      let newDates = [];
      for (var d = moment(arr[0]); d.isSameOrBefore(arr[1]); d.add(1, "days")) {
        newDates.push({date: d.format("YYYY-MM-DD"), hours: null, comment: null, notes: null});
      }
      this.tableRows.push({dates: newDates, project_id: '', activity_id: ''});
      this.isAnyRowAdded = true;
    },
  },
};
</script>
<style scoped>
.ab-cstplace {
  font-size: 14px;
  color: #adadad;
  display: block;
}

.input-wrap {
  position: relative;
}

.dropdown-toggle::after {
  position: absolute;
  right: 10px;
  top: 50%;
  color: #999999;
}

.input-wrap.select-drop.w-348 .multiselect .multiselect__select:before {
  content: none !important;
}

.modal-body {
  padding-bottom: 0px;
}

.url-inputs {
  margin: 10px 10px 10px;
}

.ab-select {
  width: 35%;
}

.wrap-width {
  width: 300px !important;
}

.text-red {
  color: red;
}

.client-table th {
  padding: 14px 5px !important;
}

.multiselct-border-design {
  color: #6c757d;
  border: 1px solid #bebebe;
  height: 40px !important;
  border-radius: 4px;
  min-height: 40px !important;
}
</style>
